import Tasks from 'APP/Tasks';
import { IDeleteScheduledMessageEventPayloadResponse } from 'APP/model/counter/counterModel.types';

import { GroupsEvent } from '../GroupsEvent';

export class ScheduledMessageWereDeleted extends GroupsEvent<IDeleteScheduledMessageEventPayloadResponse> {
  async process(): Promise<void> {
    const { messageIds = [], groupId } = this.eventPayload!;

    if (messageIds?.length) {
      Tasks.messaging.clearScheduledMessages(
        groupId.toString(),
        messageIds.map((id: string) => id)
      );
    }
  }
}
